/**
 * Qgiv Thermometer Plugin
 * requires : jQuery and RaphaelJS Libraries
 */

;(function ( $, window, document, undefined ) {
    var Thermometer = function( element, options ){
        // object reference
        var _this = this,
            el = element;

        // store elements in the object publicly
        _this.element = el;
        _this.$element = $(el);
        _this.$container = _this.$element.closest('.thermometer-container');
        _this.thermometerRect;
        _this.thermometerCirc;

        // default options
        var defaults = {
            style: 'thermometer',
            horizontal : false,
            goal : '',
            goaltype : 'default',
            achieved : '',
            fill : '#00a850',
            achievedFill: '#02d9a7',
            border : '#a9a9a9',
            refresh : 60000,
            showIncrements : true,
            showPercentages : true,
            textfill : false,
            windowStartWidth : 0,
            entity : '',
            entityType : '',
            formID : '',
            goalID : '',
            aggregatedForms : '',
            aggregatedItems: '',
            aggregatedThermType: '',
            disableUpdates: false
        };

       _this.settings = $.extend({}, defaults, options);

       _this.w = 95;
       _this.h = 210;

        // check if this is a horizontal or vertical thermometer
        if ( typeof _this.$element.attr('data-layout') !== 'undefined' ){
            _this.settings.horizontal = _this.$element.attr('data-layout') === 'horizontal' ? true : false;
        }

        // check if this is an SVG or Simple thermometer
        if ( typeof _this.$element.attr('data-style') !== 'undefined' ){
            _this.settings.style = _this.$element.attr('data-style');
        }

        if ( _this.settings.horizontal ){
            _this.w = 218;
            _this.h = 95;
        }

        // private variables. Setting the initial Paper variable and its dependencies to blank, so that if Simple style is enabled,
        //                    Raphael won't try to inject any SVG into the markup
        var id = el.id,
            controlID = _this.$element.closest('.widget').attr('data-id'),
            paper = '',
            thermometerFill = '',
            thermometerBorder = '',
            increments = '',
            incrementNumbers = '',
            thermometerSet = '';

        if ( _this.settings.style === 'thermometer' ) {
            // updating all SVG-related values
            paper = Raphael(id, _this.w, _this.h),
            thermometerFill = paper.set(),
            thermometerBorder = paper.set(),
            increments = paper.set(),
            incrementNumbers = paper.set(),
            thermometerSet = paper.set();
            // Raphael create method
            Raphael.el.create = function (attributes) {
                this.attr(attributes);
            };
            Raphael.st.create = function (attributes) {
                this.forEach(function (el) {
                    el.create(attributes);
                });
            };
        }

        // init AutoNumeric to apply currency formatting to Custom Goal for Aggregator Events
        if ( _this.$element.find('#thermometer-goalcustom-' + controlID) ) {
            AutoNumericNumber('#thermometer-goalcustom-' + controlID);
        }

        if ( _this.$element.find('#thermometer-amtgoal-' + controlID) ) {
            AutoNumericNumber('#thermometer-amtgoal-' + controlID);
        }

        if ( _this.$element.find('#thermometer-qtygoal-' + controlID) ) {
            AutoNumericNumber('#thermometer-qtygoal-' + controlID);
        }

        // using refresh rate as a toggle for updating data
        if ( _this.settings.refresh && !_this.settings.disableUpdates ) {
            setInterval(function(){
                _this.updateThermometer();
            }, _this.settings.refresh);
        }

        this.updateThermometer = function() {
            var _data = { 
                'entity' : _this.settings.entity,
                'entityType' : _this.settings.entityType
            };

            // if we have a goal, use it
            if ( _this.settings.goalID.length > 0 ) {
                _data = { 
                    'entity' : _this.settings.entity,
                    'entityType' : _this.settings.entityType, 
                    'goal' : _this.settings.goalID
                };
            };

            // if we have aggregated forms and events, use them
            if ( _this.settings.aggregatedForms.length > 0 ) {
                _data = { 
                    'entity' : _this.settings.entity,
                    'entityType' : _this.settings.entityType,
                    'goaltype' : _this.settings.goaltype,
                    'aggregated_forms' : _this.settings.aggregatedForms,
                    'aggregated_items' : _this.settings.aggregatedItems,
                    'aggregated_therm_type' : _this.settings.aggregatedThermType
                };
            };

            // get updated thermometer achieved amount
            $.fn.qpost({
                csrf : false,
                url : ('/event/' + _this.settings.formID + '/thermometer/'),
                type : 'post',
                dataType : 'json',
                data : _data,
                success: function(response){
                    if ( response.success ) {
                        _this.hideStats();
                        _this.settings.achieved = response.total;
                        var achieved = _this.settings.goaltype === 'qty' ? number_format(_this.settings.achieved, 0) :
                             _this.formatCurrency(_this.settings.achieved);
                        _this.$container.find('.current-stat .js-thermometer-stat-value').text(achieved);
                        _this.updateAmount();
                    }
                }
            });

        };

        this.hideStats = function(){
            _this.$container.find('.thermometer-stats').addClass('fade-out-content');
        };

        this.revealStats = function(){
            _this.$container.find('.thermometer-stats').removeClass('fade-out-content').addClass('fade-in-content');
            setTimeout(function() {
                _this.$container.find('.thermometer-stats').removeClass('fade-in-content');
            }, 300);
        };

        this.formatCurrency = function(value){
            var value = value || 0.00,
                symbol = ( typeof QGIV.Form !== 'undefined' ) ? QGIV.Form.currency.symbol : '$',
                location = ( typeof QGIV.Form !== 'undefined' ) ? QGIV.Form.currency.symbolLocation : 0,
                format = ( typeof QGIV.Form !== 'undefined' ) ? QGIV.Form.currency.format : 0,
                formattedValue = currencyFormat(value, format);

            return ( location ) ? formattedValue + symbol : symbol + formattedValue;
        };

        this.updateAmount = function(amount) {
            _this.settings.achieved = amount || _this.settings.achieved;

            // ensure that Achieved and Goal amounts are always in number format
            if ( typeof _this.settings.goal === 'string' ) {
                _this.settings.goal = parseFloat(String(_this.settings.goal).replace(/,/g, ''));
            }
            if ( typeof _this.settings.achieved === 'string' ) {
                _this.settings.achieved = parseFloat(String(_this.settings.achieved).replace(/,/g, ''));
            }

            // figure out the percentage
            var percentage = (_this.settings.achieved >= _this.settings.goal) ? 100 : (_this.settings.achieved/_this.settings.goal) * 100,
                floatedPercentage = Math.floor((_this.settings.achieved/_this.settings.goal) * 100);

            // update for Simple Thermometer
            if ( _this.settings.style === 'simple' ) {
                if ( _this.$container.find('.percentage-amount').length || _this.$container.find('.js-progress-percent').length ) {
                    if ( $.isNumeric(floatedPercentage) && floatedPercentage > 0 ) {
                        _this.$container.find('.js-progress-percent').text(floatedPercentage + '%');
                    // if at 0% completion, change the color of the percentage value to stand out
                    } else {
                        _this.$container.find('.js-progress-percent').text('0%');
                        _this.$container.find('.js-progress-percent').css('color', _this.settings.fill);
                    }
                }

                if ( floatedPercentage > 0 ) {
                    // add class to animate the width/height if we have a fill greater than 0
                    _this.$container.find('.js-progress-bar-fill').addClass('has-progress');

                    // apply the width/height of the fill bar
                    if (_this.settings.horizontal) {
                        _this.$container.find('.js-progress-bar-fill').css('width', (floatedPercentage + '%'));
                    } else {
                        _this.$container.find('.js-progress-bar-fill').css('height', (floatedPercentage + '%'));
                    }
                }

            // update for Classic Thermometer
            } else {
                // figure out the coordinates to represent the percentage
                var yPos = ((100 - percentage) * 1.35) + 9,
                    fillHeight = 165 - yPos;

                // prepare the animation to set the thermometer
                animateThermometer = Raphael.animation({height: fillHeight, y: yPos}, 1000, 'linear');

                // animate the thermometer to the percentage achieved unless it's at 0
                if ( percentage > 0 ) {
                    thermometerFill.animate(animateThermometer);
                }

                if (_this.$container.find('.percentage-amount').length) {
                    if ( $.isNumeric(floatedPercentage) && floatedPercentage > 0 ) {
                        _this.$container.find('.percentage-amount .js-thermometer-stat-value').text(floatedPercentage + '%');
                    }  else {
                        _this.$container.find('.percentage-amount .js-thermometer-stat-value').text('0%');
                    }
                }
            }

            // reveal our stats
            _this.revealStats();
            _this.capTextWidth();

            if ( _this.settings.textfill ) {   
                UI.throttle(function(){
                    var currentWidth = window.innerWidth;

                    if ( currentWidth !== _this.settings.windowStartWidth ) {
                        Embed.resize();
                        _this.capTextWidth();

                        _this.settings.windowStartWidth = currentWidth;
                    }
                }, 800);
            }

            // show animated stripes for 100%+ goal achieved
            if ( _this.settings.achieved >= _this.settings.goal ) {
                // The stripe animation only works for SVG
                if ( _this.settings.style === 'thermometer' ) {
                    setTimeout(function() {
                        addStripes();
                    }, 1200);
                }

                function addStripes() {
                    var id = _this.$element[0].id + '-stripePattern',
                        pattern = document.createElementNS('http://www.w3.org/2000/svg', 'pattern'),
                        stripes = paper.set(),
                        poly1 = paper.path('M50,0 37.5,0 50,12.5').attr({ fill: _this.settings.achievedFill, stroke: 'none' });
                        poly2 = paper.path('M50,12.5 37.5,0 12.5,0 50,37.5').attr({ fill: _this.settings.fill, stroke: 'none' });
                        poly3 = paper.path('M50,50 50,37.5 12.5,0 0,0 0,12.5 37.5,50').attr({ fill: _this.settings.achievedFill, stroke: 'none' });
                        poly4 = paper.path('M0,12.5 0,37.5 12.501,50 37.5,50').attr({ fill: _this.settings.fill, stroke: 'none' });
                        poly5 = paper.path('M0,50 12.5,50 0,37.5').attr({ fill: _this.settings.achievedFill, stroke: 'none' });

                    pattern.setAttribute('id', id);
                    pattern.setAttribute('x', 0);
                    pattern.setAttribute('y', 0);
                    pattern.setAttribute('height', 50);
                    pattern.setAttribute('width', 50);
                    pattern.setAttribute('patternUnits', 'userSpaceOnUse');
                    pattern.setAttribute('patternContentUnits', 'userSpaceOnUse');
                    pattern.setAttribute('patternTransform', 'translate(0, 0)');

                    $(pattern).append( poly1[0], poly2[0], poly3[0], poly4[0], poly5[0] );
                    $(pattern).appendTo(paper.defs);

                    _this.$container.addClass('goal-achieved')
                        .find('svg > rect, svg > circle').attr('fill', 'url(#' + id + ')');

                    var stripeCount = 0;

                    function scrollStripes() {
                        stripeCount++;

                        pattern.setAttribute('patternTransform', 'translate(' + stripeCount + ', 0)');

                        // Fix for IE to refresh SVG each frame
                        if ( $('html').hasClass('no-smil') ) {
                            if ( ! $('.frame-element').length ){
                                _this.$container.append('<span class="frame-element hide-content"></span>');
                            } else{
                                $('.frame-element').toggleClass('hide-content');
                            }
                        }
                    }

                    var requestAnimationFrame = window.requestAnimationFrame ||
                                                window.mozRequestAnimationFrame ||
                                                window.webkitRequestAnimationFrame ||
                                                window.msRequestAnimationFrame ||
                                                function(callback) { window.setTimeout(callback, 0); };

                    (function animloop(){
                        setTimeout(function() {
                            requestAnimationFrame(animloop);
                            scrollStripes();                            
                        }, 1000 / 45);
                    })();
                };
            }
        };

        // CustomEvent() polyfill for IE 9+ to fix bug with fitty
        // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
        this.checkCustomEventSupport = function() {
            if ( typeof window.CustomEvent === "function" ) return false;

            function CustomEvent ( event, params ) {
                params = params || { bubbles: false, cancelable: false, detail: null };
                var evt = document.createEvent( 'CustomEvent' );
                    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                return evt;
            }

            CustomEvent.prototype = window.Event.prototype;
            window.CustomEvent = CustomEvent;
        };

        this.capTextWidth = function() {
            _this.$container.find('.thermometer-stats').find('.current-stat, .goal-stat, .daterange').find('.thermometer-stat-value').each(function() {
                var thisLength = $(this).find('span').text().length;

                $(this)
                    .removeClass('width-65 width-75 width-95');

                if ( thisLength <= 6 ) {
                    // $0.00 - $99.99
                    $(this).addClass('width-65');
                } else if ( thisLength > 6 && thisLength <= 9 ) {
                    // $100.00 - $9,999.99
                    $(this).addClass('width-75');
                } else {
                    // $99,999.00 +
                    $(this).addClass('width-95');
                }
            });

            _this.$container.find('.thermometer-stats .percentage-stat .thermometer-stat-value').each(function() {
                var thisLength = $(this).find('span').text().length;

                $(this)
                    .removeClass('width-40 width-65 width-80');

                if ( thisLength <= 2 ) {
                    // 0% - 9%
                    $(this).addClass('width-40');
                } else if ( thisLength > 2 && thisLength <= 4 ) {
                    // 10% - 999%
                    $(this).addClass('width-65');
                } else {
                    $(this).addClass('width-80');
                }
            });

            // polyfill IE11 bug from CustomEvent with fitty plugin
            _this.checkCustomEventSupport();

            // run fitty plugin when CustomEvent is recognized as a function
            if ( typeof window.CustomEvent === "function" ) {
                fitty('.js-thermometer-stat-value', {
                    maxSize : 50
                });
            }
        };

        this.initSVGThermometer = function() {
            // set up initial canvas size
            paper.setViewBox(0, 0, _this.w, _this.h, false);

            // make it flexible
            paper.canvas.setAttribute('preserveAspectRatio', 'xMinYMin meet');
            paper.canvas.setAttribute('width', '100%');
            paper.canvas.setAttribute('height', '100%');

            thermometerBorder.push(
            // darker inset
            paper.path('M57.644,209.4c-19.619,0-35.582-15.962-35.582-35.582c0-10.004,4.218-19.532,11.601-26.273V12c0-7.458,3.959-11.4,11.449-11.4h25.103c10.088,0,11.448,5.763,11.448,11.4v135.578c7.359,6.739,11.563,16.255,11.563,26.239C93.226,193.438,77.263,209.4,57.644,209.4 M45.111,4.201c-5.502,0-7.849,2.332-7.849,7.8v137.17l-0.618,0.537c-6.979,6.084-10.982,14.871-10.982,24.11c0,17.635,14.346,31.981,31.981,31.981c17.635,0,31.982-14.347,31.982-31.981c0-9.22-3.992-17.996-10.949-24.079l-0.614-0.538V12c0-5.285-1.175-7.8-7.849-7.8H45.111z').attr({fill: '#8B8A88'}),
            // main border
            paper.path('M56.644,209.4c-19.619,0-35.582-15.962-35.582-35.582c0-10.004,4.218-19.532,11.601-26.273V12c0-7.458,3.959-11.4,11.449-11.4h25.103c10.088,0,11.448,5.763,11.448,11.4v135.578c7.359,6.739,11.563,16.255,11.563,26.239C92.226,193.438,76.263,209.4,56.644,209.4 M44.111,4.201c-5.502,0-7.849,2.332-7.849,7.8v137.17l-0.618,0.537c-6.979,6.084-10.982,14.871-10.982,24.11c0,17.635,14.346,31.981,31.981,31.981c17.635,0,31.982-14.347,31.982-31.981c0-9.22-3.992-17.996-10.949-24.079l-0.614-0.538V12c0-5.285-1.175-7.8-7.849-7.8H44.111z').attr({fill: '#ABAAA7'})
            );
            thermometerBorder.create({
                stroke: 'none'
            });

            // branded thermometer fill
            _this.thermometerRect = paper.rect(42, 165, 30, 0, 6),
            _this.thermometerCirc = paper.circle(57, 174, 28);

            thermometerFill.push(
                _this.thermometerRect,
                _this.thermometerCirc
            );
            thermometerFill.create({
                fill: _this.settings.fill, 
                stroke: 'none'
            });


            // fill glare
            var fillGlare = paper.path('M42.042,43.569l-0.12,106.401c-8.454,5.245-13.292,13.54-13.403,23.968c-0.169,15.793,12.446,26.488,24.699,27.915c0,0,9.258-2.719,12.615-15.261c2.182-8.147,1.941-21.167-7.166-29.5C46.789,146.223,42.042,43.569,42.042,43.569').attr({fill: '#fff', opacity: 0.175, stroke: 'none'});

            // diagonal dashes for percentage indicators
            if ( _this.settings.showIncrements ){
                increments.push(
                    paper.path('M25 7L34.75 10'),
                    paper.path('M25 20.5L34.75 23.5'),
                    paper.path('M25 34L34.75 37'),
                    paper.path('M25 47.5L34.75 50.5'),
                    paper.path('M25 61L34.75 64'),
                    paper.path('M25 74.5L34.75 77.5'),
                    paper.path('M25 88L34.75 91'),
                    paper.path('M25 101.5L34.75 104.5'),
                    paper.path('M25 115L34.75 118'),
                    paper.path('M25 128.5L34.75 131.5'),
                    paper.path('M25 142L34.75 145')
                );
                increments.create({
                    stroke: _this.settings.border, 
                    'stroke-linecap': 'round', 
                    'stroke-width': 2
                });
            }

            let _100p;
            let _80p;
            let _60p;
            let _40p;
            let _20p;
            let _0p;

            if ( _this.settings.horizontal ){
                thermometerSet.push(
                    thermometerBorder,
                    thermometerFill,
                    fillGlare,
                    increments
                );
                thermometerSet.transform('t210, 0r90, 0, 0');

                // horizontal layout for the percentages
                _100p = paper.text(218, 15, '100%');
                _80p = paper.text(187, 15, '80%');
                _60p = paper.text(160, 15, '60%');
                _40p = paper.text(131, 15, '40%');
                _20p = paper.text(106, 15, '20%');
                _0p = paper.text(76, 15, '0%');
            } else {
                _100p = paper.text(20, 6, '100%');
                _80p = paper.text(20, 33, '80%');
                _60p = paper.text(20, 60, '60%');
                _40p = paper.text(20, 87, '40%');
                _20p = paper.text(20, 114, '20%');
                _0p = paper.text(20, 141, '0%');
            }

            _this.incrementNumberCount = 0;

            if (_this.incrementNumberCount < 3) {
                setTimeout(() => {
                    _this.incrementNumberCount = _this.incrementNumberCount + 1
                    incrementNumbers.push(
                        _100p,
                        _80p,
                        _60p,
                        _40p,
                        _20p,
                        _0p  
                    );
                    incrementNumbers.create({
                        fill: '#5C5C5B', 
                        'font-size': 8.5, 
                        'font-weight': 'normal', 
                        'text-anchor': 'end'
                    });
                }, 400);
            } 
       
            // script for scaling VML graphics for IE6-8
            if( $('html').hasClass('lt-ie9') ){
                // set up the initial size
                var w = $('#'+ id).parent().width(),
                h = $('#'+id).parent().height();

                paper.setSize(w, h);

                // adjust on window resize
                UI.throttle(function(){
                    var w = $('#'+id).parent().width(),
                        h = $('#'+id).parent().height();

                    paper.setSize(w, h);
                });
            }

            // update amounts
            setTimeout( function(){
                _this.updateAmount();
            }, 500);
        };

        this.initSimpleThermometer = function() {
            // color the stats and fill bar, display the percentage completed
            _this.$container.find('.js-progress-bar-fill').css('background-color', _this.settings.fill);
            _this.initSimpleThermometerCount = 0;
            // apply the width/height of the outer bar
            if (_this.settings.horizontal) {
                _this.w = _this.$container.find('.thermometer-content').width();

                if (_this.w === 0 && _this.initSimpleThermometerCount < 3) {
                    setTimeout(() => {
                        _this.initSimpleThermometerCount = _this.initSimpleThermometerCount + 1;
                        _this.initSimpleThermometer();
                    }, 500);
                    return;
                }

                _this.$container.find('.js-goal-progress-bar').css('width', _this.w);
            } else {
                _this.h = _this.$container.find('.thermometer-content').height();
                _this.$container.find('.js-goal-progress-bar').css('height', _this.h);
            }

            // update amounts
            setTimeout( function(){
                _this.updateAmount();
            }, 500);
        };

        // init the thermometer, based on display type
        if ( _this.settings.style === 'simple' ) { this.initSimpleThermometer(); }
        else { this.initSVGThermometer(); }

        // countdown
        if ( _this.$container.find('.thermometer-countdown').length ) {
            var days, hours, minutes, seconds, countdownInterval,
                // get tag element
                $counter = _this.$container.find('.thermometer-countdown'),
                event_date = $counter.attr('data-event-date'),
                // set the date we're counting down to
                target_date = new Date(event_date).getTime(),
                current_date = new Date().getTime();

                // run the countdown if target date hasnt been reached,
                // otherwise, hide the countdown
                if ( target_date >= current_date ) {
                    // update every 1 second
                    countdownInterval = setInterval(function () {
                        // find the amount of 'seconds' between now and target
                        var seconds_left = (target_date - current_date) / 1000;

                        // do some time calculations
                        days = parseInt(seconds_left / 86400);
                        seconds_left = seconds_left % 86400;
                         
                        hours = parseInt(seconds_left / 3600);
                        seconds_left = seconds_left % 3600;
                         
                        minutes = parseInt(seconds_left / 60);
                        seconds = parseInt(seconds_left % 60);

                        if ( target_date >= current_date ) {
                            // format countdown string + set tag value
                            $counter.find('.counter-days').text(days);
                            $counter.find('.counter-hours').text(hours);
                            $counter.find('.counter-minutes').text(minutes);
                            $counter.find('.counter-seconds').text(seconds);
                        } else {
                            // auto hide when the countdown reaches 0, clear the interval
                            $counter.addClass('hide-content');
                            clearInterval(countdownInterval);
                        }

                        // countdown on the current date
                        current_date = current_date + 1000;
                    }, 1000);
                } else {
                    $counter.addClass('hide-content');
                }

        }

        if ( _this.$container.find('.thermometer-button').length ) {
            _this.$container.find('.thermometer-button:not(.js-prevent-redirect)').on('click', function(e){
                var href = $(this).attr('href'),
                    hasTarget = $(this).attr('target'),
                    newTab = e.shiftKey || e.ctrlKey || e.metaKey;

                if ( typeof hasTarget === 'undefined' && !newTab ) {
                    window.top.location.href = href;
                    e.preventDefault();
                }
            });
        }

        // track whether the fill color has been changed from the default,
        // so that the theme Primary Color (form.theme) may override it
        _this.$container.closest('.cms-control').find('.widget-thermometer-fill').on('change', function(){ 
            $(this).attr('data-custom-fill', 'true');
        });
    };

    $.fn.thermometer = function ( options ) {
        this.each(function() {
            if ( !$.data( this, 'qg_thermometer' ) ) {
                $.data( this, 'qg_thermometer', new Thermometer( this, options ) );
            }
        });

        // chain jQuery functions
        return this;
    };
     
})( jQuery, window, document );
